import type { MaasModelSourceStackScope } from '@/delivery-type-plugin/capabilities/maas-init/maasTypes';

import type { AvailableModelRepoItem } from './type';

/** 从平台内置模型仓库制品解析 stackscope 来源（与后端 MaaSModelSourceStackScope 字段一致） */
export function getStackScopeSourceFromArtifact(item: AvailableModelRepoItem): MaasModelSourceStackScope {
  const model = String(item.options?.modelRepo?.modelName || item.name || '').trim();
  const url = String(item.gitRefUrl || '').trim();
  return { model, url };
}

/** 制品模型大小: 字符串，自带单位 */
export function getArtifactModelSizeBytes(item: AvailableModelRepoItem): string {
  return item.gitSourceSize || '';
}

/** 当前表单 stackscope 是否与制品匹配 */
export function isStackScopeSourceMatch(item: AvailableModelRepoItem, source?: Partial<MaasModelSourceStackScope>): boolean {
  const model = String(source?.model || '').trim();
  const url = String(source?.url || '').trim();
  if (!model || !url) return false;
  const expected = getStackScopeSourceFromArtifact(item);
  return expected.model === model && expected.url === url;
}
